import { useCallback, useState } from 'react';

// Whether Build drafts a plan to approve before spending the credit.
//
// On by default: the plan is free and a build is a credit, and approving the
// pages first is what stops a wrong build being paid for twice. Someone who
// always skips it switches it off once — the choice is remembered per browser.
//
// Storage is a convenience here, not the source of truth for a build: the
// switch's position at the moment Build is pressed travels to /build in router
// state (Workspace → GenerationView's `planFirst`). So a browser with storage
// blocked still builds the way the switch showed; it just forgets next visit.
const PLAN_FIRST_KEY = 'bl_plan_first';

export function readPlanFirst() {
  try { return localStorage.getItem(PLAN_FIRST_KEY) !== '0'; } catch { return true; }
}

export function writePlanFirst(on) {
  try { localStorage.setItem(PLAN_FIRST_KEY, on ? '1' : '0'); } catch { /* remembered for this page only */ }
}

/** The switch's state, read once and written through on every change. */
export function usePlanFirst() {
  const [planFirst, setPlanFirst] = useState(readPlanFirst);
  const set = useCallback((on) => { setPlanFirst(on); writePlanFirst(on); }, []);
  return [planFirst, set];
}
